import './Button.css';

export default function Button({
  href,
  onClick,
  variant = 'primary',
  children,
  fullWidth = false,
  type = 'button',
  className = '',
  target,
  rel,
}) {
  const cls = `btn btn--${variant}${fullWidth ? ' btn--full' : ''} ${className}`.trim();

  if (href) {
    return (
      <a href={href} className={cls} target={target} rel={rel}>
        {children}
      </a>
    );
  }

  return (
    <button type={type} onClick={onClick} className={cls}>
      {children}
    </button>
  );
}
